import { render } from "./MusicPlayerComponent.vue?vue&type=template&id=4c909a32&scoped=true&ts=true"
import script from "./MusicPlayerComponent.vue?vue&type=script&lang=ts"
export * from "./MusicPlayerComponent.vue?vue&type=script&lang=ts"

import "./MusicPlayerComponent.vue?vue&type=style&index=0&id=4c909a32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c909a32"]])

export default __exports__